import React, { Component } from "react";
import TournamentMatchDetail from "./presenter";

class Container extends Component {
  render() {
    return <TournamentMatchDetail {...this.state} {...this.props} />;
  }
}

export default Container;
